import { Typography } from 'styles';
import { IClaimBillingHistory } from 'types/Claim';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

type Props = {
	item: IClaimBillingHistory;
};

const BillingContent = ({ item }: Props) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});

	return (
		<Typography variant="body">
			{tClientLabels('claim.history.billingStatusChanged', {
				status: tDbLabels(item.label),
			})}
		</Typography>
	);
};

export default BillingContent;
